import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle
} from 'react'

// eslint-disable-next-line no-unused-vars
import { ITabs, ITabsRef, ITab } from '../../interfaces/tabs'

import { TabsContext } from '../../contexts/tabs'

import { Header } from './Header'
import { Paginate } from './Paginate'

import { Container, Section, SectionsWrapper } from './styles'

const ForwardTabs: React.ForwardRefRenderFunction<ITabsRef, ITabs> = (
  props,
  ref
) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const [render, setRender] = useState<ITab[]>([])

  useEffect(() => {
    setRender(props.render)
  }, [props.render])

  const sectionsWrapperRef = useRef(null)

  const gotoTab = useCallback((nextTab: number) => {
    setCurrentIndex(nextTab - 1)
  }, [])

  useEffect(() => {
    props.onChange && props.onChange(currentIndex + 1)
  }, [currentIndex])

  const isCurrentTab = (currentTab: number, index: number) => {
    return currentTab === index ? 'selected' : ''
  }

  const isDisabled = (status?: boolean) => {
    return status ? 'disabled' : ''
  }

  const onGotoTab = useCallback((nextTab: number) => {
    gotoTab(nextTab + 1)
  }, [])

  useImperativeHandle(ref, () => ({
    gotoTab
  }))

  const renderSection = () => {
    if (!render[currentIndex]) return null

    return <Section>{render[currentIndex].section}</Section>
  }

  return (
    <TabsContext.Provider
      value={{ currentIndex, onGotoTab, isCurrentTab, isDisabled, props }}
    >
      <Container>
        {!props.pagination && <Header />}

        <SectionsWrapper ref={sectionsWrapperRef}>
          {renderSection()}
        </SectionsWrapper>

        {props.pagination && <Paginate />}
      </Container>
    </TabsContext.Provider>
  )
}

export const Tabs = forwardRef(ForwardTabs)
